import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
export default function Logout() {
  const { resetUser } = useAuth();

  resetUser();

  return <Navigate to={"/"} />;
}
